import { installPulseGlobal } from "./global";

installPulseGlobal(globalThis);
